<template>
    <az-modal v-if="deveMostarMensagem" :min-width="300" :maxWidth="tamanhoMaximo">
        <span slot="title">{{ titulo }}</span>

        <div slot="body" class="mensagem-confirmacao__texto px-1">
            <h4 v-show="textoPrimario" class="mb-1">
                <strong>{{ textoPrimario }}</strong>
            </h4>

            <p v-show="textoSecundario" class="mensagem-confirmacao__texto-secundario">
                {{ textoSecundario }}
            </p>
        </div>

        <div class="mensagem-confirmacao__acao" slot="actions">
            <az-call-to-action v-if="comBotaoCancelar" id="botaoCancelar" @click="$emit('cancelar')" slot="actions"
                               css-class="botao">
                {{ botaoCancelar }}
            </az-call-to-action>

            <az-call-to-action v-if="comBotaoConfirmar" id="botaoConfirmar" @click="$emit('confirmar')" slot="actions"
                               css-class="botao-primario">
                {{ botaoConfirmar }}
            </az-call-to-action>
        </div>
    </az-modal>
</template>

<script>
export default {
    name: 'ModalMostarMensagem',
    props: {
        deveMostarMensagem: {
            type: Boolean,
            default: false
        },
        comBotaoCancelar: {
            type: Boolean,
            default: false
        },
        comBotaoConfirmar: {
            type: Boolean,
            default: false
        },
        titulo: {
            type: String,
            default: 'Texto da mensagem'
        },
        textoPrimario: {
            type: String,
            default: ''
        },
        textoSecundario: {
            type: String,
            default: ''
        },
        botaoCancelar: {
            type: String,
            default: 'Cancelar'
        },
        botaoConfirmar: {
            type: String,
            default: 'Confirmar'
        },
        tamanhoMaximo: {
            type: String,
            default: '400'
        }
    }
}
</script>

<style scoped lang="stylus">
    .mensagem-confirmacao
        &__texto
            text-align justify
            color #777

        &__texto-secundario
            width 80%
            margin 0 auto

        &__acao
            text-align center
            margin-bottom 16px

            .botao
                color #777 !important
                border 0

            .botao:first-child
                margin-right 10px

            .botao-primario, .botao
                text-transform uppercase
                font-size 13px

            .botao-primario
                background-color var(--v-primary-lighten1) !important
                color #fff !important
                border 1px solid var(--v-primary-lighten1)
</style>